<script lang="ts" setup>
import type { FilterProduct } from '~~/server/api/insurance/assistance-services/[slug]'

export interface WidgetAssistanceServicesFilter {
    filterData: FilterProduct[];
}

const route = useRoute()
const router = useRouter()
const { $t } = useNuxtApp()
const props = defineProps<WidgetAssistanceServicesFilter>()
const buttonsRef = ref<HTMLButtonElement[]>([])

const isActive = (product: FilterProduct, index: number): boolean => {
    return product.id === Number(route.query.products_id) ||
        (!route.query.products_id && index === 0)
}

const handleClick = (productId: number, index: number): void => {
    router.push(
        useNamedRoutes({
            name: 'assistance-services-detail',
            params: { id: route.params.id as string },
            query: {
                filter: 'products',
                products_id: productId,
            },
        })
    )

    // Keep focus on the button after route change and data re-fetch (WCAG 2.4.3)
    // setTimeout with 150ms delay ensures focus is set after re-render completes
    setTimeout(() => {
        const buttonEl = buttonsRef.value[index]
        buttonEl?.focus()
    }, 150)
}

const setButtonRef = (el: any, index: number): void => {
    if (el) {
        buttonsRef.value[index] = el.$el || el
    }
}
</script>
<template>
  <ScrollSection
    class="g-2 mb-8"
    role="group"
    :aria-label="$t('Filtrovať podľa produktu')"
  >
    <ScrollSectionItem
      v-for="(product, index) in props.filterData"
      :key="`assist-prod-${index}`"
      class="flex-shrink-0 col-auto"
    >
      <VButton
        :ref="(el: any) => setButtonRef(el, index)"
        type="button"
        color="tertiary"
        :class="{
          'is-active': isActive(product, index),
        }"
        :aria-pressed="isActive(product, index)"
        :label="product.title"
        @click="handleClick(product.id, index)"
      >
        {{ product.title }}
      </VButton>
    </ScrollSectionItem>
  </ScrollSection>
</template>
